import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=4ec37978&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec37978",
  null
  
)

export default component.exports